<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-12">
            <h5 class="card-title font-weight-bold mb-0">{{$t('medium_grant_ev.admissibility__admissibility')}}</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8"></div>
          <div class="col-lg-2 vertical-border">
            <div class="row">
              <div class="col-lg-6">
                {{$t('medium_grant_ev.general__yes')}}
              </div>
              <div class="col-lg-6">
                {{$t('medium_grant_ev.general__no')}}
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-8">
            {{$t('medium_grant_ev.admissibility__app_submitted')}}
          </div>
          <div class="col-lg-2 vertical-border">
            <div class="row">
              <div class="col-lg-6">
                <radio name="model.submission_type"
                       value="true"
                       v-model="EvaluationForm.model.submission_type"
                >
                </radio>
              </div>
              <div class="col-lg-6">
                <radio name="model.submission_type"
                       value="false"
                       v-model="EvaluationForm.model.submission_type"
                >
                </radio>
              </div>
            </div>
          </div>
          <div class="col-lg-2"></div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-8">
            {{$t('medium_grant_ev.admissibility__relevant_forms_signed')}}
          </div>
          <div class="col-lg-2 vertical-border">
            <div class="row">
              <div class="col-lg-6">
                <radio name="model.forms_signed"
                       value="true"
                       v-model="EvaluationForm.model.forms_signed"
                >
                </radio>
              </div>
              <div class="col-lg-6">
                <radio name="model.forms_signed"
                       value="false"
                       v-model="EvaluationForm.model.forms_signed"
                >
                </radio>
              </div>
            </div>
          </div>
          <div class="col-lg-2"></div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-8">
            <!--{{$t('medium_grant_ev.admissibility__requested_funding_more')}}-->
            {{$t('medium_grant_cn_ev.admissibility_biopama_ac_funding_complies')}}
          </div>
          <div class="col-lg-2 vertical-border">
            <div class="row">
              <div class="col-lg-6">
                <radio name="model.ac_funding"
                       value="true"
                       v-model="EvaluationForm.model.ac_funding"
                >
                </radio>
              </div>
              <div class="col-lg-6">
                <radio name="model.ac_funding"
                       value="false"
                       v-model="EvaluationForm.model.ac_funding"
                >
                </radio>
              </div>
            </div>
          </div>
          <div class="col-lg-2"></div>
        </div>
        <div class="row mt-4">
         <div class="col-lg-8">
           <!--{{$t('medium_grant_ev.admissibility__requested_co_funding_at_least')}}-->
           {{$t('medium_grant_cn_ev.admissibility_co_funding_total_project_value')}}
         </div>
         <div class="col-lg-2 vertical-border">
           <div class="row">
             <div class="col-lg-6">
               <radio name="model.co_funding"
                      value="true"
                      v-model="EvaluationForm.model.co_funding"
               >
               </radio>
             </div>
             <div class="col-lg-6">
               <radio name="model.co_funding"
                      value="false"
                      v-model="EvaluationForm.model.co_funding"
               >
               </radio>
             </div>
           </div>
         </div>
         <div class="col-lg-2"></div>
       </div>

        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="font-weight-bold">
              {{$t('medium_grant_ev.general__comments_action_points')}}
            </h5>
            <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_admissibility" :comments="EvaluationForm.model.comments_admissibility"></comment-box>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-lg-12">
            <h5 class="card-title font-weight-bold">Eligibility</h5>
            <h6 class="card-title font-weight-bold mb-0">Applicants</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8"></div>
          <div class="col-lg-2 vertical-border">
            <div class="row">
              <div class="col-lg-6">
                {{$t('medium_grant_ev.general__yes')}}
              </div>
              <div class="col-lg-6">
                {{$t('medium_grant_ev.general__no')}}
              </div>
            </div>
          </div>
          <div class="col-lg-2"></div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-8">
            {{$t('medium_grant_ev.admissibility__coapplicants_meet_eligibility')}}
          </div>
          <div class="col-lg-2 vertical-border">
            <div class="row">
              <div class="col-lg-6">
                <radio name="model.meet_eligibility"
                       value="true"
                       v-model="EvaluationForm.model.meet_eligibility"
                >
                </radio>
              </div>
              <div class="col-lg-6">
                <radio name="model.meet_eligibility"
                       value="false"
                       v-model="EvaluationForm.model.meet_eligibility"
                >
                </radio>
              </div>
            </div>
          </div>
          <div class="col-lg-2"></div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="font-weight-bold">
              {{$t('medium_grant_ev.general__comments_action_points')}}
            </h5>
            <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_applicants" :comments="EvaluationForm.model.comments_applicants"></comment-box>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-lg-8">
            <h6 class="card-title font-weight-bold mb-0">
              {{$t('medium_grant_ev.admissibility__project_activities')}}
            </h6>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8"></div>
          <div class="col-lg-2 vertical-border">
            <div class="row">
              <div class="col-lg-6">
                {{$t('medium_grant_ev.general__yes')}}
              </div>
              <div class="col-lg-6">
                {{$t('medium_grant_ev.general__no')}}
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-8">
            {{$t('medium_grant_ev.admissibility__proposed_activities_eligible')}}
          </div>
          <div class="col-lg-2 vertical-border">
            <div class="row">
              <div class="col-lg-6">
                <radio name="model.proposed_activities_eligible"
                       value="true"
                       v-model="EvaluationForm.model.proposed_activities_eligible"
                >
                </radio>
              </div>
              <div class="col-lg-6">
                <radio name="model.proposed_activities_eligible"
                       value="false"
                       v-model="EvaluationForm.model.proposed_activities_eligible"
                >
                </radio>
              </div>
            </div>
          </div>
          <div class="col-lg-2"></div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-8">
            {{$t('medium_grant_ev.admissibility__clear_address')}}
          </div>
          <div class="col-lg-2 vertical-border">
            <div class="row">
              <div class="col-lg-6">
                <radio name="model.clear_priority"
                       value="true"
                       v-model="EvaluationForm.model.clear_priority"
                >
                </radio>
              </div>
              <div class="col-lg-6">
                <radio name="model.clear_priority"
                       value="false"
                       v-model="EvaluationForm.model.clear_priority"
                >
                </radio>
              </div>
            </div>
          </div>
          <div class="col-lg-2"></div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="font-weight-bold">
              {{$t('medium_grant_ev.general__comments_action_points')}}
            </h5>
            <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_project_activities" :comments="EvaluationForm.model.comments_project_activities"></comment-box>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-lg-8">
            <h6 class="card-title font-weight-bold mb-0">{{$t('medium_grant_ev.admissibility__costs')}}</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8"></div>
          <div class="col-lg-2 vertical-border">
            <div class="row">
              <div class="col-lg-6">
                {{$t('medium_grant_ev.general__yes')}}
              </div>
              <div class="col-lg-6">
                {{$t('medium_grant_ev.general__no')}}
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-8">
            {{$t('medium_grant_ev.admissibility__costs_eligible')}}
          </div>
          <div class="col-lg-2 vertical-border">
            <div class="row">
              <div class="col-lg-6">
                <radio name="model.proposed_costs_eligible"
                       value="true"
                       v-model="EvaluationForm.model.proposed_costs_eligible"
                >
                </radio>
              </div>
              <div class="col-lg-6">
                <radio name="model.proposed_costs_eligible"
                       value="false"
                       v-model="EvaluationForm.model.proposed_costs_eligible"
                >
                </radio>
              </div>
            </div>
          </div>
          <div class="col-lg-2"></div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="font-weight-bold">
              {{$t('medium_grant_ev.general__comments_action_points')}}
            </h5>
            <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_costs" :comments="EvaluationForm.model.comments_costs"></comment-box>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-lg-8">
            <h6 class="card-title font-weight-bold mb-0">
              {{$t('medium_grant_ev.admissibility__environmental')}}
            </h6>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8"></div>
          <div class="col-lg-2 vertical-border">
            <div class="row">
              <div class="col-lg-6">
                {{$t('medium_grant_ev.general__yes')}}
              </div>
              <div class="col-lg-6">
                {{$t('medium_grant_ev.general__no')}}
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-8">
            {{$t('medium_grant_ev.admissibility__environmental_concern')}}
          </div>
          <div class="col-lg-2 vertical-border">
            <div class="row">
              <div class="col-lg-6">
                <radio name="model.environmental"
                       value="true"
                       v-model="EvaluationForm.model.environmental"
                >
                </radio>
              </div>
              <div class="col-lg-6">
                <radio name="model.environmental"
                       value="false"
                       v-model="EvaluationForm.model.environmental"
                >
                </radio>
              </div>
            </div>
          </div>
          <div class="col-lg-2"></div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="font-weight-bold">
              {{$t('medium_grant_ev.general__comments_action_points')}}
            </h5>
            <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_environmental" :comments="EvaluationForm.model.comments_environmental"></comment-box>
          </div>
        </div>

      </div>
      <div class="col-lg-3">
        <info-right></info-right>
      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      InfoRight,
      CommentBox
    },
    data() {
      return {
        EvaluationForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
    }
  }
</script>
